import { prerender } from "$app/server";
import { ServerVelatlasApi } from "$lib/api/velatlas/velatlas.api.server";
import { ATLAS_CITY_FEATURE_FILTER_OPTIONS, CityFeatureType } from "$lib/features/cityFeature/cityFeatureType.enum";
import { featureMapPointToAtlasFeatureMapPoint, type AtlasFeatureMapPoint } from "$lib/models/atlasFeatureMapPoint";
import * as v from 'valibot';

const api = new ServerVelatlasApi();

export const getAllTypeFeatures = prerender(
    v.object({
        cityFeatureType: v.enum(CityFeatureType)
    }),
    async ({ cityFeatureType }): Promise<AtlasFeatureMapPoint[]> => {
        console.log("Getting all type features", { cityFeatureType });
        return (await api.getAllFeatureMapPoints([cityFeatureType])).map(featureMapPointToAtlasFeatureMapPoint).filter((f) => f !== null);
    },
    {
        inputs: () => {
            const filterableTypes: CityFeatureType[] = ATLAS_CITY_FEATURE_FILTER_OPTIONS.map(item => item.type);
            return filterableTypes.map(type => ({ cityFeatureType: type }));
        }
    }
);